import { Container, Reveal } from '@/components/common'
import { usePageTitle } from '@/hooks'

const sections = [
  {
    heading: 'Introduction',
    body: [
      'IBON World ("we", "our", or "us") respects your privacy and is committed to protecting the personal information you share with us. This policy explains what information we collect, how we use it, and the choices you have.',
    ],
  },
  {
    heading: 'Information We Collect',
    body: [
      'We may collect information you provide directly, such as your name, email address, and message content when you use our contact form or newsletter signup.',
      'We may also collect limited technical information automatically, such as browser type and general usage data, to help us understand how our website is used.',
    ],
  },
  {
    heading: 'How We Use Your Information',
    body: [
      'We use the information we collect to respond to enquiries, send updates you have requested, improve our website and programmes, and communicate about partnerships, donations, and events.',
      'We do not sell your personal information to third parties.',
    ],
  },
  {
    heading: 'Cookies',
    id: 'cookies',
    body: [
      'Our website may use cookies and similar technologies to remember preferences and understand how visitors interact with our site. You can control or disable cookies through your browser settings at any time.',
    ],
  },
  {
    heading: 'Data Sharing',
    body: [
      'We may share information with trusted service providers who help us operate our website and programmes (such as email delivery services), and only to the extent necessary for them to perform those services.',
    ],
  },
  {
    heading: 'Data Security',
    body: [
      'We take reasonable measures to protect the information you share with us. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.',
    ],
  },
  {
    heading: 'Your Rights',
    body: [
      'You may request access to, correction of, or deletion of your personal information at any time by contacting us using the details below.',
    ],
  },
  {
    heading: 'Changes to This Policy',
    body: [
      'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.',
    ],
  },
  {
    heading: 'Contact Us',
    body: [
      'If you have questions about this Privacy Policy, please reach out via our Contact page.',
    ],
  },
]

export const PrivacyPage = () => {
  usePageTitle('Privacy Policy')

  return (
    <>
      <section className="bg-ibon-dark py-24 lg:py-32">
        <Container>
          <Reveal variant="up" delay={100}>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-ibon-sky">Legal</p>
            <h1 className="mt-4 text-4xl font-bold leading-[1.03] tracking-[-0.02em] text-white sm:text-5xl">
              Privacy Policy
            </h1>
            <p className="mt-4 text-sm text-white/50">Last updated: August 2026</p>
          </Reveal>
        </Container>
      </section>

      <section className="bg-white py-20 lg:py-28">
        <Container>
          <div className="mx-auto max-w-3xl space-y-14">
            {sections.map(({ heading, body, id }) => (
              <div key={heading} id={id}>
                <h2 className="text-2xl font-bold tracking-tight text-ibon-dark">{heading}</h2>
                <div className="mt-4 space-y-4">
                  {body.map((paragraph) => (
                    <p key={paragraph} className="text-base leading-relaxed text-text-muted">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  )
}
